import {
  Box,
  Checkbox,
  Divider,
  Grid,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import React, { useState, useContext, useEffect } from 'react';
import KenInput from '../../../../../KenInput';
import KenSelect, { CustomIcon } from '../../../../../KenSelect';
import KenPhoneInput from '../../../../../KenPhoneInput';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import KenRadioGroup from '../../../../../KenRadioGroup';
import KenDocumentUpload from '../../../../../KenDocumentUpload';
import { UploadDocumentContext } from '../../../../../../Context/uploadDocumentContext';
import { AuthContext } from '../../../../../../Context/authContext';
import { makeStyles } from '@mui/styles';
import KenFieldArray from '../../../../../KenFieldArray';
import FieldArray from '../../../../../KenApplication/FieldArray';
import getValidation from '../../../../../../Utils/Helpers/validationHelper';
import KenLoader from '../../../../../KenLoader';
import { useApplicationContext } from '../../../../../../Context/applicationContext';
import {
  getCities,
  getCountries,
  getStates,
} from '../../../../../../Utils/apiServices';
import moment from 'moment';
import KenDateField from '../../../../../KenDateField';
import KenTextLabel from '../../../../../KenTextLabel';
import KenIcon from '../../../../../KenIcon';
import ErrorIcon from '../../../../../../Assets/Icons/error.png';
import { matchIsValidTel } from 'mui-tel-input';
import { Autocomplete } from '@mui/material';
import KenTextField from '../../../../../KenTextField';

const useStyles = makeStyles((theme) => ({
  phoneContainerClass: {
    '& .phone-input': {
      height: '57px !important',
      width: '100%',
    },
  },
  formFieldLabel: {
    'font-style': 'normal',
    'font-weight': '400',
    'font-size': '14px',
    'line-height': '100%',
    color: '#505F79',
  },
  inputFieldLabelClass: {
    color: '#505F79',
    'font-size': '12px',
    'line-height': '16px',
    'margin-bottom': '6px',
    'text-transform': 'capitalize',
    fontWeight: 500,
  },
  datePickerClass: {
    '&  button.MuiIconButton-edgeEnd': {
      marginLeft: 0,
      marginRight: theme.spacing(1),
    },
  },
}));

// Minimum age, in months, a student must have reached to be admitted.
const MIN_AGE_MONTHS = 30; // 2.5 years

// Date of Birth needs bounds the generic date widget does not enforce: the
// picker's maxDate only greys out calendar cells, and the text field is
// editable, so a typed or pasted date reaches form state unchecked. An
// unparseable entry also formats to the truthy string 'Invalid date', which
// satisfies `required`. Scoped to DOB by field name so other date fields
// (Passport Expiry needs future dates, Transfer Certificate its own bound)
// keep their existing behaviour.
const isDateOfBirthField = (name) =>
  typeof name === 'string' && name.includes('dateOfBirth');

const validateDateOfBirth = (value) => {
  if (!value) return null; // `required` owns the empty case
  if (value === 'Invalid date') return 'Please enter a valid date of birth';

  const dob = moment(value, 'YYYY-MM-DD', true);
  if (!dob.isValid()) return 'Please enter a valid date of birth';

  const today = moment().startOf('day');
  if (dob.isAfter(today, 'day')) {
    return 'Date of birth cannot be a future date';
  }
  if (today.diff(dob, 'months', true) < MIN_AGE_MONTHS) {
    return 'Student must be at least 2.5 years old';
  }
  return null;
};

// Parent/guardian emails must differ from the student's: the backend resolves
// the logged-in contact by email, so a relation sharing the student's email
// makes the next login land on the relation (Father's name, no applications).
// Matches both `applicantRelations[0][email]` and `applicantRelations.0.email`.
const isRelationEmailField = (name) =>
  typeof name === 'string' &&
  /^applicantRelations(\[\d+\]\[email\]|\.\d+\.email)$/.test(name);

const normalizeEmail = (email) =>
  typeof email === 'string' ? email.trim().toLowerCase() : '';

const validateRelationEmail = (value, studentEmails) => {
  const email = normalizeEmail(value);
  if (!email) return null; // `required` owns the empty case
  if (studentEmails.some((e) => normalizeEmail(e) === email)) {
    return "Email must be different from the student's email";
  }
  return null;
};

const KenWidget = (props) => {
  const {
    ui, //TODO: ui.divider added only for select and input. Add it for all widgets.
    type,
    name,
    // label,
    description,
    fieldId,
    lastItem,
    // isFormValid,
    // options,
    validations = {},
    fieldsArray,
    validationType,
    // getFormValues,
  } = props;
  // TODO: Create a new component for upload and Move this context
  const { state, dispatch } = useContext(UploadDocumentContext);
  const { state: authState } = useContext(AuthContext) || {};
  const classes = useStyles();
  const methods = useFormContext();
  const [objectName, setObjectName] = useState();
  const [fieldName, setFieldName] = useState();
  const errors = methods.formState.errors;
  //   console.log("errors in form", methods.formState.errors);
  const [size, setSize] = useState();

  useEffect(() => {
    let customGrid = {
      xs: ui?.grid?.xs ? ui?.grid?.xs : 12,
      sm: ui?.grid?.sm ? ui?.grid?.sm : 12,
      md: ui?.grid?.md ? ui?.grid?.md : 6,
      lg: ui?.grid?.lg ? ui?.grid?.lg : 6,
    };
    if (ui?.gridType) {
      switch (ui?.gridType) {
        case 'fullRow':
          customGrid = { xs: 12, sm: 12, md: 12, lg: 12 };
          break;
        case 'halfRow':
          customGrid = { xs: 12, sm: 6, md: 6, lg: 6 };
          break;
        default:
          break;
      }
    }
    setSize(customGrid);
  }, [ui]);

  const getSplicedName = (combinedName) => {
    const replaceBrackets = combinedName.replace(/[[\]']+/g, ' ');
    const splitStr = replaceBrackets?.split(' ');
    if (Array.isArray(splitStr) && splitStr.length > 0) {
      setObjectName(splitStr[0]);
      setFieldName(splitStr[1]);
    }
  };

  useEffect(() => {
    getSplicedName(name);
  }, [name]);

  useEffect(() => {
    // console.log("errors", errors);
    for (const [key, value] of Object.entries(errors)) {
      console.log(`${key}: ${value}`);
    }

    const isEmpty = Object.keys(errors).length === 0;
    if (isEmpty) {
      // isFormValid(true);
    } else {
      // isFormValid(false);
    }
  }, [errors]);

  const handleFileChange = (file, index) => {
    // console.log("file", file);
    dispatch({
      type: 'upload',
      payload: {
        id: fieldId,
        name: name,
        label: props.label,
        description: description,
        previewImage: file,
      },
    });
  };

  const getFieldLevelValidation = (fieldValidations, value, data) => {
    const validationScope = fieldValidations?.scope;
    const validationRule = fieldValidations?.rule;
    const scopeValue = data?.type === 'date' ? methods.getValues(validationScope) : parseFloat(methods.getValues(validationScope));
    const ownValue = data?.type === 'date' ? value : parseFloat(value);
    switch (validationRule) {
      case 'GREATER':
        if (scopeValue > ownValue) {
          return fieldValidations?.message;
        }
        break;
      case 'LESSER':
        if (scopeValue < ownValue) {
          return fieldValidations?.message;
        }
        break;
      default:
        break;
    }
  };

  const getValidations = (validate) => {
    const validateCopy = { ...validate };
    if (
      validateCopy?.pattern &&
      typeof validateCopy?.pattern?.value !== 'object'
    ) {
      validateCopy.pattern.value = getValidation(validationType);
    }
    return validateCopy;
  };

  const handleFileDelete = (name) => {
    const index = state.newlyAddedFiles?.findIndex(
      (item) => item.name === name
    );
    dispatch({
      type: 'delete',
      payload: index,
    });
  };

  const getElementError = (data, name) => {
    const allData = Object.values(data);
    const index = allData?.findIndex((elem) => elem?.ref?.name === name);
    if (index > -1) {
      return allData[index]?.message;
    } else {
      return data?.message;
    }
  };

  const getPreviewImage = () => {
    const newFiles = state.newlyAddedFiles;
    const file = newFiles.find((item) => item.name === name);
    return file?.previewImage || false;
  };

  const getField = (type) => {
    switch (type) {
      case 'autocomplete':
        return (
          <>
            {props?.options?.length > 0 ? (
              <Controller
                name={props.name}
                control={props.control}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <>
                    {props.label && (
                      <KenTextLabel
                        label={props.label}
                        required={props.required}
                      />
                    )}
                    <Autocomplete
                      options={props.options}
                      getOptionLabel={(option) => option.label || ''}
                      value={props.options.find(option => option.value === value) || null}
                      onChange={(event, newValue) => {
                        onChange(newValue ? newValue.value : null);
                      }}
                      renderInput={(params) => (
                        <>
                          <Box display={'flex'} alignItems={'center'}>
                            <KenTextField
                              {...params}
                              {...props}
                              label={props.label}
                              error={!!error}
                              helperText={error ? error.message : null}
                              inputProps={{
                                ...params.inputProps,
                                className: `${error ? `${classes.input} ${classes.error}` : classes.input}`,
                                maxCharacters: 50,
                              }}
                            />
                            {error?.message && (
                              <Box width="16px" height="16px" margin="19px 8px">
                                <KenIcon
                                  iconType="img"
                                  icon={ErrorIcon}
                                  variant="extraSmall"
                                />
                              </Box>
                            )}
                          </Box>
                          {error && (
                            <Typography
                              variant="subtitle1"
                              style={{ color: 'red', fontWeight: 400 }}
                              align="left"
                            >
                              {error.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </>
                )}
                {...methods.register(name, validations)}
              />
            ) : null}
          </>
        );
      case 'select':
        return (
          <>
            {props?.options?.length > 0 ||
            Object.keys(props?.options).length > 0 ? (
              <Controller
                name={`${name}`}
                control={methods.control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => {
                  return (
                    <KenSelect
                      textFieldProps={{
                        SelectProps: {
                          IconComponent: CustomIcon,
                        },
                      }}
                      {...props}
                      onChange={onChange}
                      value={value}
                      error={error?.message}
                    />
                  );
                }}
                {...methods.register(name, validations)}
              />
            ) : (
              ''
            )}
          </>
        );
      case 'multiSelect':
        return (
          <>
            {props?.options?.length > 0 && (
              <Controller
                name={`${name}`}
                control={methods.control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => {
                  return (
                    <>
                      {props.label && (
                        <KenTextLabel
                          label={props.label}
                          required={props.required}
                        />
                      )}
                      <Box display={'flex'} alignItems={'center'}>
                        <Select
                          sx={{
                            width: '100%',
                            background: '#f3f5f7',
                            '.MuiOutlinedInput-notchedOutline': {
                              border: error?.message
                                ? '1px solid #FC2C32'
                                : 'none',
                            },
                          }}
                          multiple
                          renderValue={(selected) => {
                            console.log(selected, '65u56u5u5i');
                            let data = [];
                            (selected || [])?.forEach((el) => {
                              data.push(
                                props?.options?.find(
                                  (elem) => elem.value === el
                                )?.label
                              );
                            });
                            return data.join(', ');
                          }}
                          value={
                            value
                              ? typeof value === 'string'
                                ? value?.split(';')
                                : value
                              : []
                          }
                          onChange={onChange}
                        >
                          {props?.options?.map((items, index) => {
                            return (
                              <MenuItem
                                style={{
                                  display: 'flex',
                                  justifyContent: 'start',
                                  alignItems: 'center',
                                  padding: '20px',
                                }}
                                key={index}
                                value={items?.value}
                              >
                                <Checkbox
                                  sx={{
                                    margin: '0px 10px 0px 0px',
                                    padding: '0px',
                                  }}
                                  checked={
                                    (value ? value : []).indexOf(items.value) >
                                    -1
                                  }
                                />
                                <Box
                                  sx={{
                                    marginY: '0px',
                                    paddingY: '0px',
                                    textWrap: 'wrap',
                                  }}
                                >
                                  {items?.label}
                                </Box>
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {error?.message && (
                          <Box width="16px" height="16px" margin="19px 8px">
                            <KenIcon
                              iconType="img"
                              icon={ErrorIcon}
                              variant="extraSmall"
                            />
                          </Box>
                        )}
                      </Box>
                      {error && (
                        <Typography
                          variant="subtitle1"
                          style={{ color: 'red', fontWeight: 400 }}
                          align="left"
                        >
                          {error.message}
                        </Typography>
                      )}
                    </>
                  );
                }}
                {...methods.register(name, validations)}
              />
            )}
          </>
        );
      case 'input':
        return (
          <Controller
            name={`${name}`}
            control={methods.control}
            render={({ field, fieldState: { error } }) => (
              <>
                <KenInput {...props} {...field} error={error?.message} />
              </>
            )}
            {...methods.register(name, {
              ...getValidations(validations),
              validate: (value) => {
                if (isRelationEmailField(name)) {
                  const relationEmailError = validateRelationEmail(value, [
                    methods.getValues('applicant.email'),
                    authState?.user?.applicantEmail,
                  ]);
                  if (relationEmailError) return relationEmailError;
                }
                return (
                  getFieldLevelValidation(props?.validateField, value) || null
                );
              },
            })}
          />
        );

      case 'textArea':
        return (
          <Controller
            name={`${name}`}
            control={methods.control}
            render={({ field, fieldState: { error } }) => (
              <>
                <KenInput
                  {...props}
                  {...field}
                  multiline={true}
                  minRows={3}
                  error={error?.message}
                />
              </>
            )}
            {...methods.register(name, validations)}
          />
        );

      case 'phone':
        return (
          <Controller
            name={`${name}`}
            control={methods.control}
            rules={{
              ...validations,
              validate: (value) => {
                return value !== ''
                  ? matchIsValidTel(value) ||
                      'Please enter a valid phone number'
                  : true;
              },
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <KenPhoneInput
                  inputFieldLabelClass={`${classes.inputFieldLabel}`}
                  variant="outlined"
                  errorLabel={true}
                  {...field}
                  {...props}
                  setValue={methods.setValue}
                  error={error?.message}
                />
              );
            }}
          />
        );
      case 'radio':
        return (
          <Controller
            name={`${name}`}
            control={methods.control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <KenRadioGroup
                {...props}
                labelClassName={classes.formFieldLabel}
                onChange={onChange}
                value={value}
                error={error?.message}
              />
            )}
            {...methods.register(name, validations)}
          />
        );
      case 'upload':
        return (
          <Controller
            name={`${name}`}
            control={methods.control}
            render={({ field: { onChange, value } }) => (
              <>
                <KenDocumentUpload
                  {...props}
                  onChange={(files) => {
                    handleFileChange(files[0], name);
                  }}
                  key={props?.fieldId}
                  previewImage={getPreviewImage()}
                  removeFile={() => {
                    handleFileDelete(name);
                  }}
                  value={value}
                />
                {(!lastItem || ui?.divider) && <Divider></Divider>}
              </>
            )}
            {...methods.register(name, validations)}
          />
        );

      case 'addMultiple': {
        return (
          <KenFieldArray
            {...props}
            bunchOfFields={fieldsArray}
            fieldArrayName={`${name}`}
            defaultObject={fieldsArray && fieldsArray[0]}
            error={
              methods.formState.errors &&
              methods.formState.errors[objectName] &&
              methods.formState.errors[objectName][fieldName] &&
              getElementError(
                methods.formState.errors[objectName][fieldName],
                name
              )
            }
            {...methods.register(name, validations)}
          />
        );
      }

      case 'array':
        return <FieldArray {...props} />;

      case 'address':
        return <Address {...props} />;

      case 'date':
        return (
          <Controller
            name={`${name}`}
            control={methods.control}
            render={({ field, fieldState: { error } }) => {
              return (
                <KenDateField {...field} {...props} error={error?.message} />
              );
            }}
            {...methods.register(name, {
              ...getValidations(validations),
              validate: (value) => {
                if (isDateOfBirthField(name)) {
                  const dobError = validateDateOfBirth(value);
                  if (dobError) return dobError;
                }
                return (
                  getFieldLevelValidation(props?.validateField, value, props) || null
                );
              },
            })}
          />
        );

      default:
        return (
          <Controller
            name={`${name}`}
            control={methods.control}
            render={({ field, fieldState: { error } }) => (
              <>
                <KenInput {...props} {...field} error={error?.message} />
              </>
            )}
            {...methods.register(name, validations)}
          />
        );
    }
  };

  return type !== 'addMultiple' &&
    type !== 'address' &&
    type !== 'array' &&
    size ? (
    // data-field-name lets the stepper find and focus the first invalid field on Next
    <Grid item xs={size.xs} md={size.md} lg={size.lg} textAlign="left" data-field-name={name}>
      {props && getField(type)}
    </Grid>
  ) : (
    <>{props && getField(type)}</>
  );
};
export default KenWidget;

const Address = function (props) {
  const { options: fields = [], name } = props;
  const { applicationState } = useApplicationContext();

  const { getValues, setValue, clearErrors, unregister } = useFormContext();

  const {
    mailingCountry,
    mailingState,
    country: addressCountry,
    state: addressState,
    hed__MailingCountry__c,
    hed__MailingState__c,
    // mailingDistrict,
    // city: addressCity,
    // hed__MailingCity__c,
  } = getValues(`${name}`) || {};
  const watchCountry = useWatch(`${name}`);

  const [country, setCountry] = useState();
  const [countries, setCountries] = useState([]);
  const [state, setState] = useState();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);

  const addressNameCustomization = (customName) => {
    return `${name}${customName}`.replace('[', '.').replace(']', '.');
  };

  const searchForAddressValue = (addressName) => {
    const addressData = applicationState?.applicationData;
    if (!addressData || !addressName) {
      return undefined;
    }
    const [firstKey, secondKey, thirdKey] = addressName.split('.');
    return addressData?.[firstKey]?.[secondKey]?.[thirdKey];
  };

  // GET All Countries
  useEffect(() => {
    setLoading(true);
    getCountries()
      .then((res) => {
        const countries = res.map((items) => {
          return {
            ...items,
            label: items.name,
            value: items.name,
          };
        });
        setCountries(countries);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [mailingCountry]);

  // GET Single Country
  useEffect(() => {
    const hasCountry =
      mailingCountry || addressCountry || hed__MailingCountry__c;
    if (hasCountry && countries.length > 0) {
      setLoading(true);
      const getCountry =
        countries.find((items) => {
          return items.value === hasCountry;
        }) || undefined;
      setCountry(getCountry);
      setStates([]);
      setCities([]);
      setLoading(false);
    }
  }, [mailingCountry, addressCountry, hed__MailingCountry__c, countries]);

  // GET All States
  useEffect(() => {
    const stateKeys = ['mailingState', 'addressState', 'hed__MailingState__c'];
    let hasState;
    let keyWhichHasValue;

    // To get state data in both backend and in application wise
    stateKeys?.forEach((items) => {
      const hasValue =
        getValues(addressNameCustomization(items)) ||
        searchForAddressValue(addressNameCustomization(items));
      if (hasValue) {
        hasState = hasValue;
        keyWhichHasValue =
          addressNameCustomization(items) || addressNameCustomization(items);
      }
    });

    if (country) {
      setLoading(true);
      getStates(country?.iso2)
        .then((res) => {
          const states = res.map((items) => {
            return {
              ...items,
              label: items.name,
              value: items.name,
            };
          });

          // For Validating fields in every country (Depended Field) change
          const getState = res?.filter((items) => {
            return items?.name === hasState;
          });
          const state = getState.length > 0 ? getState[0] : undefined;
          if (state === undefined) {
            // unregister(keyWhichHasValue);
          } else {
            setCities([]);
            // clearErrors(keyWhichHasValue);
            setValue(keyWhichHasValue, hasState);
          }
          setStates(states);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [mailingCountry, country]);

  // GET Single State
  useEffect(() => {
    const hasState = hed__MailingState__c || mailingState || addressState;
    if (country && hasState && states.length > 0) {
      setLoading(true);
      const getSingleState = states?.find((items) => {
        return items.value === hasState;
      });
      setState(getSingleState);
      setCities([]);
      setLoading(false);
    }
  }, [mailingCountry, country, mailingState, addressState, hed__MailingState__c, states]);

  // GET All Cities
  useEffect(() => {
    const cityKeys = ['mailingDistrict', 'addressCity', 'hed__MailingCity__c'];
    let hasCities;
    let keyWhichHasValue;

    // To get city data in both backend and in application wise
    cityKeys?.forEach((items) => {
      const hasValue =
        getValues(addressNameCustomization(items)) ||
        searchForAddressValue(addressNameCustomization(items));
      if (hasValue) {
        hasCities = hasValue;
        keyWhichHasValue =
          addressNameCustomization(items) ||
          searchForAddressValue(addressNameCustomization(items));
      }
    });
    if (state && country) {
      setLoading(true);
      getCities(country?.iso2, state?.iso2)
        .then((res) => {
          const cities = res.map((items) => {
            return {
              label: items.name,
              value: items.name,
            };
          });

          // For Validating fields in every State (Depended Field) change
          const getCities = res?.filter((items) => {
            return items?.name === hasCities;
          });
          const city = getCities.length > 0 ? getCities[0] : undefined;
          if (city === undefined) {
            console.log(keyWhichHasValue, '45y46y56u56u56u');
            // unregister(keyWhichHasValue);
          } else {
            // clearErrors(keyWhichHasValue);
            // setValue(keyWhichHasValue, hasCities);
          }
          setCities(cities);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [state, country]);

  useEffect(() => {
    console.log(watchCountry);
  }, [watchCountry]);

  const getOptions = ({ fieldId }) => {
    switch (fieldId) {
      case 'mailingCountry':
        return countries;
      case 'country':
        return countries;
      case 'hed__MailingCountry__c':
        return countries;
      case 'applicant[Qualification_Country__c]':
        return countries;
      case 'Country__c':
        return countries;
      case 'mailingState':
        return states;
      case 'state':
        return states;
      case 'hed__MailingState__c':
        return states;
      case 'mailingDistrict':
        return cities;
      case 'city':
        return cities;
      case 'hed__MailingCity__c':
        return cities;
      default:
        return [];
    }
  };

  return (
    <>
      {loading && <KenLoader />}
      {fields.map((field) => {
        return (
          <>
            {getOptions(field).length > 0 ? (
              <KenWidget
                {...field}
                name={`${name}[${field?.name}]`}
                options={getOptions(field)}
              />
            ) : null}
          </>
        );
      })}
    </>
  );
};
